import * as React from "react"
import {DiplomaGrid} from "./diploma/DiplomaGrid";
import {Box} from "@chakra-ui/react";
import Header from "./components/Header";
import {Routes, Route} from "react-router-dom";
import DiplomaPreview from "./diploma/DiplomaPreview";
import {useState} from "react";
import Denied from "./components/Denied";
import {useKeycloak} from "@react-keycloak/web";

export default function MainView() {
    const [searchString, setSearchString] = useState<string>('');
    const { keycloak, }= useKeycloak();

    const updateSearchString = (searchString: React.SetStateAction<string>) => {
        setSearchString(searchString);
    }

    if(!keycloak.hasResourceRole("admin", "dyplomy")) {
        return <Denied/>
    }
    return (
        <>
            <Header passSearchToParent={updateSearchString}/>
            <Box marginTop={{ base: "240px", sm: "90px", md: "100px" }} padding={"24px"} textAlign="center" fontSize="xl">
                <Routes>
                    <Route path={`view/:uuid`}>
                        <DiplomaPreview/>
                    </Route>
                    <Route path='/'>
                        <DiplomaGrid searchString={searchString}/>
                    </Route>
                </Routes>
            </Box>
        </>
    )
}